export const CITIES = [
  "אבו בלאל",
    "אבו גווייעד",
    "אבו גוש",
    "אבו געדה",
    "אבו דיס",
    "אבו חמרה",
    "אבו טוילה",
    "אבו סנאן",
    "אבו סריחאן",
    "אבו עבדון",
    "אבו עמאר",
    "אבו עמרה",
    "אבו קורינאת",
    "אבו קרינאת",
    "אבו קש",
    "אבו רובייעה",
    "אבו רוקייק",
    "אבו שחידם",
    "אבו תלול",
    "אבטין",
    "אבטליון",
    "אביאל",
    "אביבים",
    "אביגדור",
    "אביחיל",
    "אביטל",
    "אביעזר",
    "אבירים",
    "אבן יהודה",
    "אבן מנחם",
    "אבן ספיר",
    "אבן שמואל",
    "אבני איתן",
    "אבני חפץ",
    "אבנת",
    "אבשלום",
    "אבתאן",
    "אג'נסניא",
    "אדורה",
    "אדירים",
    "אדמית",
    "אדנה",
    "אדרת",
    "אהלו",
    "אודים",
    "אודלה",
    "אודם",
    "אוהד",
    "אום אל-פחם",
    "אום אל-קוטוף",
    "אום אל תות",
    "אום בטין",
    "אומן",
    "אומץ",
    "אופקים",
    "אוצרין",
    "אור הגנוז",
    "אור הנר",
    "אור יהודה",
    "אור עקיבא",
    "אורה",
    "אורות",
    "אורטל",
    "אורים",
    "אורנים",
    "אורנית",
    "אושה",
    "אזור",
    "אחווה",
    "אחוזם",
    "אחוזת ברק",
    "אחיהוד",
    "אחיטוב",
    "אחיסמך",
    "אחיעזר",
    "איבים",
    "אייל",
    "איילת השחר",
    "אילון",
    "אילות",
    "אילניה",
    "אילת",
    "איתמר",
    "איתן",
    "איתנים",
    "אכסאל",
    "אכתאבא",
    "אל-עזי",
    "אל-עריאן",
    "אל-רום",
    "אל בירה",
    "אל סייד",
    "אל עריש",
    "אלומה",
    "אלומות",
    "אלון הגליל",
    "אלון מורה",
    "אלון שבות",
    "אלוני אבא",
    "אלוני הבשן",
    "אלוני יצחק",
    "אלונים",
    "אלי-עד",
    "אלי סיני",
    "אליכין",
    "אליפז",
    "אליפלט",
    "אליקים",
    "אלישיב",
    "אלישמע",
    "אלמגור",
    "אלמוג",
    "אלעד",
    "אלעזר",
    "אלפי מנשה",
    "אלקוש",
    "אלקנה",
    "באגה",
    "באקה",
    "באקה אל-גרביה",
    "באקה אל שרק",
    "באר אורה",
    "באר גנים",
    "באר טוביה",
    "באר יעקב",
    "באר מילכה",
    "באר שבע",
    "בארות יצחק",
    "בארותיים",
    "בארי",
    "בגדד",
    "בדו",
    "בדולח",
    "בדיא",
    "בדרס",
    "בוגה",
    "בוסתן הגליל",
    "בועיינה-נוג'ידאת",
    "בוקעאתא",
    "בורגתה",
    "בורהאם",
    "בורין",
    "בורקה",
    "בזאריה",
    "בחן",
    "בטחה",
    "ביאדה",
    "בידא",
    "ביוכי",
    "ביצרון",
    "ביר א נצב",
    "ביר א סכה",
    "ביר אבו סוי",
    "ביר אבו צוי",
    "ביר אל-מכסור",
    "ביר אל חסי",
    "ביר אל מלחה",
    "ביר אל מעין",
    "ביר אל עבד",
    "ביר אלמיין",
    "ביר ג'אלא",
    "ביר הדאג'",
    "ביר הליל",
    "ביר זית",
    "ביר חסנה",
    "ביר לחפאן",
    "ביר מלאקי",
    "ביר מער",
    "ביר נבאלא",
    "ביר נצב",
    "ביר סדרי",
    "ביר שיח חמי",
    "ביר תל",
    "בירה חברון",
    "ביריה",
    "בית אג'זא",
    "בית אולא",
    "בית אורן",
    "בית איבא",
    "בית אכסא",
    "בית אל",
    "בית אל ב'",
    "בית אללו",
    "בית אלעזרי",
    "בית אלפא",
    "בית אמין",
    "בית אמר",
    "בית אמרין",
    "בית אענאן",
    "בית ארוש פו",
    "בית ארוש תח",
    "בית אריה",
    "בית ברל",
    "בית ג'אלא",
    "בית גוברין",
    "בית גמאל",
    "בית גמליאל",
    "בית גן",
    "בית דגן",
    "בית דקו",
    "בית הגדי",
    "בית הלוי",
    "בית הלל",
    "בית העמק",
    "בית הערבה",
    "בית השיטה",
    "בית וזן",
    "בית זיד",
    "בית זית",
    "בית זרע",
    "בית חורון",
    "בית חירות",
    "בית חלקיה",
    "בית חנון",
    "בית חנינא",
    "בית חנן",
    "בית חנניה",
    "בית חשמונאי",
    "בית יהושע",
    "בית יוסף",
    "בית ינאי",
    "בית יצחק-שער חפר",
    "בית כאחל",
    "בית לאהיה",
    "בית לחם",
    "בית לחם הגלילית",
    "בית ליד",
    "בית לקיא",
    "בית מאיר",
    "בית מחסיר",
    "בית מרסם",
    "בית נחמיה",
    "בית ניר",
    "בית נקופה",
    "בית סאחור",
    "בית סוריכ",
    "בית סירא",
    "בית עוא",
    "בית עובד",
    "בית עוזיאל",
    "בית עזרא",
    "בית עמרא",
    "בית עריף",
    "בית פג'אר",
    "בית פוריכ",
    "בית צבי",
    "בית קאד דרו",
    "בית קאד צפו",
    "בית קמה",
    "בית קשת",
    "בית רבן",
    "בית רימא",
    "בית רימון",
    "בית שאן",
    "בית שמש",
    "בית שערים",
    "בית שקמה",
    "ביתא א תחתא",
    "ביתא פוקא",
    "ביתוניא",
    "ביתין",
    "ביתן אהרן",
    "ביתר עילית",
    "בכורה",
    "בלאטה",
    "בלעא",
    "בלעין",
    "בלפוריה",
    "בן זכאי",
    "בן עמי",
    "בן שמן",
    "בני ברק",
    "בני דקלים",
    "בני דרום",
    "בני דרור",
    "בני יהודה",
    "בני נעים",
    "בני נצרים",
    "בני סוהילה",
    "בני עטרות",
    "בני עי\"ש",
    "בני עצמון",
    "בני ציון",
    "בני ראם",
    "בניה",
    "בנימינה-גבעת עדה",
    "בסמת טבעון",
    "בענה",
    "בצרה",
    "בצת",
    "בקוע",
    "בקעות",
    "בר גיורא",
    "בר יוחאי",
    "ברג'",
    "ברדלא",
    "ברוקין",
    "ברור חיל",
    "ברוש",
    "ברטעה",
    "בריג",
    "ברכה",
    "ברכיה",
    "ברעם",
    "ברק",
    "ברקא",
    "ברקאי",
    "ברקין",
    "ברקת",
    "בת הדר",
    "בת חן",
    "בת חפר",
    "בת חצור",
    "בת ים",
    "בת עין",
    "בת שלמה",
    "בתיר",
       "ג'אלוד",
    "ג'אניה",
    "ג'ארושיה",
    "ג'בע ג'נין",
    "ג'בע רמאללה",
    "ג'בעה",
    "ג'דידה",
    "ג'דירה",
    "ג'וריש",
    "ג'ורת אל שמ",
    "ג'ז אבו רעד",
    "ג'יב",
    "ג'יביא",
    "ג'יוס",
    "ג'ית",
    "ג'לבון",
    "ג'לג'ליה",
    "ג'לזון",
    "ג'למה",
    "ג'לקמוס",
    "ג'מאלה",
    "ג'מאעין",
    "ג'ניד",
    "ג'נין",
    "ג'נצאפוט",
    "ג'רבא",
    "גאולי תימן",
    "גאולים",
    "גאליה",
    "גבאליה",
    "גבאליה העיר",
    "גבולות",
    "גבים",
    "גבל אל ערף",
    "גבל הלאל",
    "גבל חמיר",
    "גבל מגארה",
    "גבע",
    "גבע בנימין",
    "גבע כרמל",
    "גבעולים",
    "גבעון החדשה",
    "גבעות בר",
    "גבעת אבני",
    "גבעת אלה",
    "גבעת ברנר",
    "גבעת השלושה",
    "גבעת זאב",
    "גבעת ח\"ן",
    "גבעת חיים",
    "גבעת יואב",
    "גבעת יערים",
    "גבעת ישעיהו",
    "גבעת כ\"ח",
    "גבעת ניל\"י",
    "גבעת עדה",
    "גבעת עוז",
    "גבעת שמואל",
    "גבעת שמש",
    "גבעת שפירא",
    "גבעתי",
    "גבעתיים",
    "גברעם",
    "גבת",
    "גדות",
    "גדיד",
    "גדידה",
    "גדיידה-מכר",
    "גדיש",
    "גדעונה",
    "גדרה",
    "גולס",
    "גונן",
    "גורן",
    "גורנות הגליל",
    "גזית",
    "גזר",
    "גיאה",
    "גיבתון",
    "גיזו",
    "גילון",
    "גילת",
    "גינוסר",
    "גיניגר",
    "גינתון",
    "גיתה",
    "גיתית",
    "גלאון",
    "גלגוליה",
    "גלגל",
    "גליל ים",
    "גלעד",
    "גמזו",
    "גן אור",
    "גן הדרום",
    "גן השומרון",
    "גן חיים",
    "גן יאשיה",
    "גן יבנה",
    "גן נר",
    "גן שורק",
    "גן שלמה",
    "גן שמואל",
    "גנות",
    "גנות הדר",
    "גני הדר",
    "גני טל",
    "גני יהודה",
    "גני יוחנן",
    "גני מודיעין",
    "גני עם",
    "גני תקווה",
    "גנים",
    "ג'סר א-זרקא",
    "געש",
    "געתון",
    "גפן",
    "גרופית",
    "גריעה",
    "גש",
    "גשור",
    "גשר",
    "גשר הזיו",
    "גת",
    "גת קיבוץ",
    "גת בגליל",
    "גת רימון",
       "דאהריה",
    "דאלית אל-כרמל",
    "דבורה",
    "דבוריה",
    "דבירה",
    "דברת",
    "דגניה א",
    "דגניה ב",
    "דהב",
    "דהישה",
    "דהר חלת אל",
    "דוב\"ב",
    "דוגית",
    "דולב",
    "דומא חברון",
    "דומא שכם",
    "דור",
    "דורא",
    "דורות",
    "דחי",
    "דיוכ",
    "דייר חנא",
    "דייר ראפאת",
    "דימונה",
    "דיר א שמס",
    "דיר אבו דעי",
    "דיר אבו משע",
    "דיר אבזיע",
    "דיר אל-אסד",
    "דיר אל בלח",
    "דיר אל גצון",
    "דיר אל חטב",
    "דיר אל סודא",
    "דיר אל עסל",
    "דיר אסתיא",
    "דיר בלוט",
    "דיר גזאלה",
    "דיר גסאנה",
    "דיר גריר",
    "דיר דבואן",
    "דיר נזאם",
    "דיר עמאר",
    "דיר קדיס",
    "דיר רזאח",
    "דישון",
    "דליה",
    "דלתון",
    "דמיידה",
    "דן",
    "דפידף",
    "דפנה",
    "דקל",
    "דרב אל מליח",
    "דריגאת",
    "האון",
    "האשמיה",
    "הבונים",
    "הגושרים",
    "הדר עם",
    "הוד השרון",
    "הודיה",
    "הוזייל",
    "הוואשלה",
    "הושעיה",
    "הזורע",
    "הזורעים",
    "החותרים",
    "היוגב",
    "הילה",
    "המעפיל",
    "הסוללים",
    "העוגן",
    "הר אדר",
    "הר גילה",
    "הר עמשא",
    "הראל",
    "הרדוף",
    "הרצליה",
    "הררית",
    "ורד יריחו",
    "ורדון",
    "זאויה ג'נין",
    "זאויה טול כרם",
    "זבדיאל",
    "זבובה",
    "זוהר",
    "זוברה",
    "זואתה",
    "זיף",
    "זיקים",
    "זיתא",
    "זיתן",
    "זכרון יעקב",
    "זכריה",
    "זלפה",
    "זמר",
    "זמרת",
    "זנוח",
    "זעתרה",
    "זרועה",
    "זרזיר",
    "זרחיה",
    "חאן יונס",
    "חאראס",
    "חארס",
    "חבילה",
    "חבלה",
    "חבצלת השרון",
    "חבר",
    "חברון",
    "חגאגרה",
    "חגה",
    "חגור",
    "חגי",
    "חגלה",
    "חד-נס",
    "חדיד",
    "חדרה",
    "חואלד",
    "חוגייראת",
    "חולדה",
    "חולון",
    "חולית",
    "חולתה",
    "חומש",
    "חוסאן",
    "חוסן",
    "חופית",
    "חוקוק",
    "חורה",
    "חורפיש",
    "חורשים",
    "חוסנייה",
    "חזון",
    "חיפה",
    "חירות",
    "חלוץ",
    "חלחול",
    "חלמיש",
    "חלף",
    "חלץ",
    "חמאם",
    "חמד",
    "חמדיה",
    "חמדת",
    "חמרה",
    "חניאל",
    "חניתה",
    "חנתון",
    "חספין",
    "חפץ חיים",
    "חפצי-בה",
    "חצב",
    "חצבה",
    "חצור-אשדוד",
    "חצור הגלילית",
    "חצרות חולדה",
    "חצרות חפר",
    "חצרות יסף",
    "חצרים",
    "חרב לאת",
    "חריש",
    "חרמלה",
    "חרמש",
    "חרשים",
    "חשמונאים",
    "טבעון",
    "טבריה",
    "טובא-זנגריה",
    "טורעאן",
    "טייבה",
    "טירה",
    "טירת יהודה",
    "טירת כרמל",
    "טירת צבי",
    "טל-אל",
    "טל שחר",
    "טללים",
    "טלמון",
    "טמרה",
    "טנא",
    "טפחות",
    "יאטה",
    "יאנוח",
    "יאנוח-גת",
    "יאנון",
    "יאסוף",
    "יבול",
    "יבנאל",
    "יבנה",
    "יגור",
    "יגל",
    "יד בנימין",
    "יד השמונה",
    "יד חנה",
    "יד מרדכי",
    "יד נתן",
    "יד רמב\"ם",
    "ידידה",
    "יהוד-מונוסון",
    "יהל",
    "יובל",
    "יובלים",
    "יודפת",
    "יונתן",
    "יושיביה",
    "יזרעאל",
    "יחיעם",
    "יטבתה",
    "יכיני",
    "ינוב",
    "ינון",
    "יסוד המעלה",
    "יסודות",
    "יסעור",
    "יעבד",
    "יעד",
    "יעל",
    "יעף",
    "יערה",
    "יפיע",
    "יפית",
    "יפעת",
    "יפתח",
    "יצהר",
    "יציץ",
    "יקום",
    "יקיר",
    "יקנעם",
    "יקנעם עילית",
    "יראון",
    "ירדנה",
    "ירוחם",
    "ירושלים",
    "ירחיב",
    "יריחו",
    "ירכא",
    "ירקונה",
    "ישע",
    "ישעי",
    "ישרש",
    "יתד",
    "יתיר",
    "יתמא",
    "כאבול",
    "כאוכב אבו אל-היגא",
    "כברי",
    "כדורי",
    "כדים",
    "כדיתה",
    "כובר",
    "כוכב השחר",
    "כוכב יאיר",
    "כוכב יעקב",
    "כוכב מיכאל",
    "כורזים",
    "כחל",
    "כיסופים",
    "כישור",
    "כליל",
    "כלנית",
    "כמאנה",
    "כמהין",
    "כמון",
    "כנות",
    "כנף",
    "כנרת",
    "כסיפה",
    "כסלון",
    "כסרא",
    "כסרא-סמיע",
    "כעביה-טבאש-חגאגרה",
    "כפיר",
    "כפירת",
    "כפר אביב",
    "כפר אדומים",
    "כפר אוריה",
    "כפר אזר",
    "כפר אחים",
    "כפר אל דיכ",
    "כפר אל לבד",
    "כפר ביאליק",
    "כפר ביל\"ו",
    "כפר בלום",
    "כפר בן נון",
    "כפר ברא",
    "כפר ברוך",
    "כפר גדעון",
    "כפר גלים",
    "כפר גליקסון",
    "כפר גלעדי",
    "כפר דניאל",
    "כפר דרום",
    "כפר האורנים",
    "כפר החורש",
    "כפר המכבי",
    "כפר הנגיד",
    "כפר הנוער הדתי",
    "כפר הנשיא",
    "כפר הס",
    "כפר הרא\"ה",
    "כפר הרי\"ף",
    "כפר ויתקין",
    "כפר ורבורג",
    "כפר ורדים",
    "כפר זוהרים",
    "כפר זיתים",
    "כפר חב\"ד",
    "כפר חושן",
    "כפר חיטים",
    "כפר חיים",
    "כפר חנניה",
    "כפר חסידים",
    "כפר חרוב",
    "כפר טרומן",
    "כפר יאסיף",
    "כפר ידידיה",
    "כפר יהושע",
    "כפר יונה",
    "כפר יחזקאל",
    "כפר יעבץ",
    "כפר כמא",
    "כפר כנא",
    "כפר מונש",
    "כפר מימון",
    "כפר מל\"ל",
    "כפר מנדא",
    "כפר מנחם",
    "כפר מסריק",
    "כפר מצר",
    "כפר מרדכי",
    "כפר נטר",
    "כפר נעמה",
    "כפר סאלד",
    "כפר סבא",
    "כפר סילבר",
    "כפר סירקין",
    "כפר סמיע",
    "כפר עבודה",
    "כפר עזה",
    "כפר עזיז",
    "כפר עין",
    "כפר עציון",
    "כפר עקב",
    "כפר פינס",
    "כפר צור",
    "כפר קאסם",
    "כפר קדום",
    "כפר קיש",
    "כפר קרע",
    "כפר רוזנואלד",
    "כפר רופין",
    "כפר רות",
    "כפר שמאי",
    "כפר שמואל",
    "כפר שמריהו",
    "כפר תבור",
    "כפר תפוח",
    "כרזה",
    "כרכום",
    "כרם בן זמרה",
    "כרם יבנה",
    "כרם שלום",
    "כרמי יוסף",
    "כרמי צור",
    "כרמיאל",
    "כרמיה",
    "כרמים",
    "כרמל",
     "לבון",
    "לביא",
    "לבן",
    "לבן שרקיה",
    "לבנים",
    "להב",
    "להבות הבשן",
    "להבות חביבה",
    "להבים",
    "לוד",
    "לוזית",
    "לוחמי הגיטאות",
    "לוטם",
    "לוטן",
    "לימן",
    "לכיש",
    "לפיד",
    "לפידות",
    "לקיה",
    "מאדמא",
    "מאור",
    "מאיר שפיה",
    "מבוא ביתר",
    "מבוא דותן",
    "מבוא חורון",
    "מבוא חמה",
    "מבוא מודיעים",
    "מבואות ים",
    "מבועים",
    "מבטחים",
    "מבקיעים",
    "מבשרת ציון",
    "מגאר",
    "מגד",
    "מגד אל-כרום",
    "מגדים",
    "מגדל",
    "מגדל העמק",
    "מגדל עוז",
    "מגדל שמס",
    "מגדלים",
    "מגידו",
    "מגל",
    "מגן",
    "מגן שאול",
    "מגשימים",
    "מדיה",
    "מדרך עוז",
    "מדרשת בן גוריון",
    "מדרשת רופין",
    "מודיעין-מכבים-רעות",
    "מודיעין עילית",
    "מולדה",
    "מולדת",
    "מוצא עילית",
    "מוצא תחתית",
    "מוקייבלה",
    "מורג",
    "מורן",
    "מורשת",
    "מזאר",
    "מזארע אל נו",
    "מזור",
    "מזכרת בתיה",
    "מזרע",
    "מזרעה",
    "מחולה",
    "מטולה",
    "מטע",
    "מי עמי",
    "מיטב",
    "מייסר",
    "מיצר",
    "מירב",
    "מירון",
    "מישר",
    "מיתלה",
    "מיתלון",
    "מיתר",
    "מכבים",
    "מכחול",
    "מכמורת",
    "מכמנים",
    "מכר",
    "מלאה",
    "מלילות",
    "מלכיה",
    "מלכישוע",
    "מנוח",
    "מנוף",
    "מנות",
    "מנחמיה",
    "מנרה",
    "מסד",
    "מסדה",
    "מסילות",
    "מסילת ציון",
    "מסלול",
    "מסעדה",
    "מסעודין אל-עזאזמה",
    "מעאויה",
    "מעברות",
    "מעגלים",
    "מעגן",
    "מעגן מיכאל",
    "מעוז חיים",
    "מעון",
    "מעונה",
    "מעיליא",
    "מעין ברוך",
    "מעין צבי",
    "מעלה אדומים",
    "מעלה אפרים",
    "מעלה גלבוע",
    "מעלה גמלא",
    "מעלה החמישה",
    "מעלה לבונה",
    "מעלה מכמש",
    "מעלה עירון",
    "מעלה עמוס",
    "מעלה שומרון",
    "מעלות-תרשיחא",
    "מענית",
    "מעש",
    "מפלסים",
    "מצדות יהודה",
    "מצובה",
    "מצליח",
    "מצפה",
    "מצפה אבי\"ב",
    "מצפה אילן",
    "מצפה יריחו",
    "מצפה נטופה",
    "מצפה רמון",
    "מצפה שלם",
    "מצר",
    "מקווה ישראל",
    "מרגליות",
    "מרום גולן",
    "מרחב עם",
    "מרחביה",
    "מרכה",
    "מרכז שפירא",
    "משאבי שדה",
    "משגב דב",
    "משגב עם",
    "משהד",
    "משואה",
    "משואות יצחק",
    "משכיות",
    "משמר איילון",
    "משמר דוד",
    "משמר הירדן",
    "משמר הנגב",
    "משמר העמק",
    "משמר השבעה",
    "משמר השרון",
    "משמרות",
    "משמרת",
    "משען",
    "מתן",
    "מתת",
    "מתתיהו",
    "נאות גולן",
    "נאות הכיכר",
    "נאות מרדכי",
    "נאות סמדר",
    "נאעורה",
    "נבטים",
    "נגבה",
    "נגוהות",
    "נהורה",
    "נהלל",
    "נהריה",
    "נוב",
    "נוגה",
    "נווה",
    "נווה אבות",
    "נווה אור",
    "נווה אטי\"ב",
    "נווה אילן",
    "נווה איתן",
    "נווה דניאל",
    "נווה זוהר",
    "נווה זיו",
    "נווה חריף",
    "נווה ים",
    "נווה ימין",
    "נווה ירק",
    "נווה מבטח",
    "נווה מיכאל",
    "נווה שלום",
    "נויעמה",
    "נועם",
    "נוף איילון",
    "נופים",
    "נופית",
    "נופך",
    "נוקדים",
    "נורדיה",
    "נורית",
    "נחאלין",
    "נחושה",
    "נחל אדורה",
    "נחל אלישע",
    "נחל אמתי",
    "נחל גבעות",
    "נחל גנת",
    "נחל יעלון",
    "נחל מרוה",
    "נחל נצרים",
    "נחל עוז",
    "נחל עירית",
    "נחל צורף",
    "נחל צרי",
    "נחליאל",
    "נחלים",
    "נחלת יהודה",
    "נחם",
    "נחף",
    "נחשולים",
    "נחשון",
    "נחשונים",
    "נטועה",
    "נטור",
    "נטעים",
    "נטף",
    "ניין",
    "ניל\"י",
    "ניסנית",
    "ניצן",
    "ניצן ב",
    "ניצנה",
    "ניצני סיני",
    "ניצני עוז",
    "ניצנים",
    "ניר אליהו",
    "ניר בנים",
    "ניר גלים",
    "ניר דוד",
    "ניר ח\"ן",
    "ניר יפה",
    "ניר יצחק",
    "ניר ישראל",
    "ניר משה",
    "ניר עוז",
    "ניר עם",
    "ניר עציון",
    "ניר עקיבא",
    "ניר צבי",
    "נירים",
    "נירית",
    "נירן",
    "נס הרים",
    "נס עמים",
    "נס ציונה",
    "נעורים",
    "נעלה",
    "נעמ\"ה",
    "נען",
    "נצרת",
    "נצרת עילית",
    "נשר",
    "נתיב הגדוד",
    "נתיב הל\"ה",
    "נתיב העשרה",
    "נתיב השיירה",
    "נתיבות",
    "נתניה",
      "סאגור",
    "סאויה",
    "סאלם",
    "סאנור",
    "סאסא",
    "סביון",
    "סבסטיה",
    "סגולה",
    "סדום",
    "סואעד",
    "סולם",
    "סוסיה",
    "סופה",
    "סחנין",
    "סייד",
    "סילאת אל דאהר",
    "סילאת אל חארית'יה",
    "סיריס",
    "סלואד",
    "סלמאנה",
    "סלעית",
    "סלפית",
    "סמוע",
    "סמר",
    "סנג'ל",
    "סנטה קטרינה",
    "סניריה",
    "סנסנה",
    "סעד",
    "סעיר",
    "סער",
    "ספיר",
    "סרדה",
    "סתריה",
    "עאבוד",
    "עאנין",
    "עארה",
    "עארורה",
    "עבאסה",
    "עבדה",
    "עבדון",
    "עבוין",
    "עבידיה",
    "עברון",
    "עג'ה",
    "עגור",
    "עדנים",
    "עוזה",
    "עוזייר",
    "עולש",
    "עומר",
    "עופר",
    "עופרה",
    "עופרים",
    "עוצם",
    "עוקבי",
    "עוריף",
    "עורתא",
    "עזה",
    "עזוז",
    "עזון",
    "עזמוט",
    "עזר",
    "עזריאל",
    "עזריה",
    "עזריקם",
    "עטאוונה",
    "עטארה",
    "עטרת",
    "עידן",
    "עיזריה",
    "עיילבון",
    "עיינות",
    "עילוט",
    "עין א סהלה",
    "עין איוב",
    "עין איילה",
    "עין אל-אסד",
    "עין אל בידא",
    "עין גב",
    "עין גדי",
    "עין דור",
    "עין הבשור",
    "עין הוד",
    "עין החורש",
    "עין המפרץ",
    "עין הנצי\"ב",
    "עין העמק",
    "עין השופט",
    "עין ורד",
    "עין זיוון",
    "עין חצבה",
    "עין חרוד",
    "עין יברוד",
    "עין יהב",
    "עין יעקב",
    "עין כרם",
    "עין כרמל",
    "עין מאהל",
    "עין נקובא",
    "עין עירון",
    "עין צורים",
    "עין קנייא",
    "עין ראפה",
    "עין שמר",
    "עין שריד",
    "עין תמר",
    "עינת",
    "עיר אובות",
    "עכו",
    "עלאר",
    "עלומים",
    "עלי",
    "עלי זהב",
    "עלמה",
    "עלמון",
    "עמוקה",
    "עמור",
    "עמינדב",
    "עמיעד",
    "עמיעוז",
    "עמיר",
    "עמנואל",
    "עמקה",
    "ענאתא",
    "ענב",
    "ענבתא",
    "ענזה",
    "עספיא",
    "עפולה",
    "עץ אפרים",
    "עצמון שגב",
    "עקאבה",
    "עקרבה",
    "עראבה",
    "עראמשה",
    "עראנה",
    "ערד",
    "ערוגות",
    "ערערה",
    "ערערה בנגב",
    "ערקה",
    "עשרת",
    "עתיל",
    "עתלית",
    "עתניאל",
    "פארן",
    "פאת שדה",
    "פדואל",
    "פדיה",
    "פוריידיס",
    "פורת",
    "פטיש",
    "פלאמה",
    "פלך",
    "פלמחים",
    "פני חבר",
    "פסגות",
    "פסוטה",
    "פעמי תש\"ז",
    "פצאל",
    "פקועה",
    "פקיעין",
    "פקיעין חדשה",
    "פרדס חנה-כרכור",
    "פרדסיה",
    "פרוד",
    "פרזון",
    "פרי גן",
    "פתח תקווה",
    "פתחיה",
    "צאלים",
    "צבעון",
    "צובה",
    "צופיה",
    "צופים",
    "צופית",
    "צופר",
    "צוקים",
    "צור הדסה",
    "צור יגאל",
    "צור יצחק",
    "צור משה",
    "צור נתן",
    "צוריאל",
    "צורית",
    "צורן",
    "ציפורי",
    "צלפון",
    "צפריה",
    "צפרירים",
    "צפת",
    "צרופה",
    "צרעה",
    "קדומים",
    "קדימה-צורן",
    "קדמה",
    "קדמת צבי",
    "קדר",
    "קדרון",
    "קדרים",
    "קוממיות",
    "קורנית",
    "קטורה",
    "קטיף",
    "קיסריה",
    "קליה",
    "קלנסווה",
    "קלע",
    "קלקיליה",
    "קפין",
    "קציר",
    "קצרין",
    "קריות",
    "קרית אונו",
    "קרית ארבע",
    "קרית אתא",
    "קרית ביאליק",
    "קרית גת",
    "קרית טבעון",
    "קרית ים",
    "קרית יערים",
    "קרית מוצקין",
    "קרית מלאכי",
    "קרית נטפים",
    "קרית ענבים",
    "קרית עקרון",
    "קרית שלמה",
    "קרית שמונה",
    "קרני שומרון",
    "קשת",
    "ראם",
    "ראמה",
    "ראש העין",
    "ראש פינה",
    "ראש צורים",
    "ראשון לציון",
    "רבבה",
    "רווחה",
    "רוויה",
    "רוחמה",
    "רומאנה",
    "רומת הייב",
    "רועי",
    "רותם",
    "רחוב",
    "רחובות",
    "ריחאניה",
    "ריחן",
    "ריינה",
    "רימונים",
    "רינתיה",
    "רכסים",
    "רם-און",
    "רמאללה",
    "רמון",
    "רמות",
    "רמות השבים",
    "רמות מאיר",
    "רמות נפתלי",
    "רמלה",
    "רמת אפעל",
    "רמת גן",
    "רמת דוד",
    "רמת הכובש",
    "רמת השופט",
    "רמת השרון",
    "רמת יוחנן",
    "רמת ישי",
    "רמת מגשימים",
    "רמת פנקס",
    "רמת צבי",
    "רמת רזיאל",
    "רמת רחל",
    "רנן",
    "רנתיס",
    "רעים",
    "רעננה",
    "רקפת",
    "רשפון",
    "רשפים",
    "רתמים",
    "שא-נור",
    "שאר ישוב",
    "שבי ציון",
    "שבי שומרון",
    "שגב שלום",
    "שדה אילן",
    "שדה אליהו",
    "שדה אליעזר",
    "שדה בוקר",
    "שדה דוד",
    "שדה ורבורג",
    "שדה יואב",
    "שדה יעקב",
    "שדה יצחק",
    "שדה משה",
    "שדה נחום",
    "שדה נחמיה",
    "שדה ניצן",
    "שדה עוזיהו",
    "שדה צבי",
    "שדות ים",
    "שדות מיכה",
    "שדי אברהם",
    "שדי חמד",
    "שדי תרומות",
    "שדמה",
    "שדמות דבורה",
    "שדמות מחולה",
    "שדרות",
    "שואבה",
    "שובה",
    "שובל",
    "שוהם",
    "שומרה",
    "שומריה",
    "שוקדה",
    "שורש",
    "שורשים",
    "שושנת העמקים",
    "שזור",
    "שחר",
    "שחרות",
    "שיבולים",
    "שילה",
    "שילת",
    "שכניה",
    "שלוחות",
    "שלומי",
    "שלומית",
    "שמיר",
    "שמעה",
    "שמרת",
    "שמשית",
    "שניר",
    "שעב",
    "שעורים",
    "שעל",
    "שעלבים",
    "שער אפרים",
    "שער הגולן",
    "שער העמקים",
    "שער מנשה",
    "שערי תקווה",
    "שפיים",
    "שפיר",
    "שפר",
    "שפרעם",
    "שקד",
    "שקף",
    "שרונה",
    "שריגים",
    "שריד",
    "שתולה",
    "שתולים",
    "תאשור",
    "תדהר",
    "תובל",
    "תומר",
    "תושיה",
    "תימורים",
    "תירוש",
    "תל אביב",
    "תל יוסף",
    "תל יצחק",
    "תל מונד",
    "תל עדשים",
    "תל קציר",
    "תל שבע",
    "תלם",
    "תלמי אליהו",
    "תלמי אלעזר",
    "תלמי בילו",
    "תלמי יוסף",
    "תלמי יחיאל",
    "תלמים",
    "תמרת",
    "תנובות",
    "תעוז",
    "תענך",
    "תפוח",
    "תפרח",
    "תקומה",
    "תקוע",
    "תרום",
    "תרמוסעיא",
    "תרקומיא"
  ]


